<template lang="pug">
  .container
    table.table.is-bordered.is-striped.is-hoverable
      thead
        tr
          th.titulo
            a.button(title='Número de comprobante') Retención
          th.titulo
            a.button(title='Fecha de comprobante ( aaaa-mm-dd )') Fecha
          th.titulo Documento
          th.titulo Razón Social
          th.titulo Correo
          th.titulo Estado
          th.titulo PDF
          th.titulo XML
          th.titulo
            a.button(title='Autorizar') A
      tfoot
        tr
          th.titulo
            a.button(title='Número de comprobante') Retención
          th.titulo
            a.button(title='Fecha de comprobante ( aaaa-mm-dd )') Fecha
          th.titulo Documento
          th.titulo Razón Social
          th.titulo Correo
          th.titulo Estado
          th.titulo PDF
          th.titulo XML
          th.titulo
            a.button(title='Autorizar') A
      tbody
        tr(v-for = "t in tracks")
          td(v-bind:class="t.estado | estado")
              p
                | {{ t.codigo }}
              p
                | {{` ${t.establecimiento}${t.puntoEmision}${t.secuencial}` }}
          td {{ t.fecha }}
          td.numero {{ t.documento }}
          td {{ t.razonSocial }}
          td 
            a.button.button.is-text.is-outlined(
              v-on:click="enviarCorreo(t.codigo, t.numero)"
              ) {{ t.correo_electronico }}
          td
            a.button.is-info.is-outlined(
              @click="launchModal(t.codigo, t.numero)",
              v-bind:class="t.estado | estado"
              ) {{ t.estado }}
          td
            a.button.is-link.is-outlined(
              v-bind:class="t.estado | estado",
              v-bind:href="`${pdf}codigo/${t.codigo}/numero/${t.numero}`",
              target="_blank"
              ) pdf
          td
            a.button.is-success.is-outlined(
              v-bind:class="t.estado | estado",
              v-bind:href="`${xml}codigo/${t.codigo}/numero/${t.numero}`",
              target="_blank"
              ) xml
          td
            a.button.is-info.is-loading(v-show = "isLoading") A
            a.button.is-info(
              @click="autorizaUna(t.codigo, t.numero)",
              v-bind:class="t.estado+'_autorizar' | estado"
              v-show = "!isLoading"
              ) A

    .modal(v-bind:class="{'is-active':isActive}")
      .modal-background
      .modal-card
        header.modal-card-head
          p.modal-card-title Estado Electrónico
        section.modal-card-body
            p 
              strong Comprobante: 
              | {{ comprobanteEle }}
            p 
              strong Autorización: 
              | {{ autorizacionEle }}
            p 
              strong Estado:
              | {{ estadoEle }}
            p 
              strong Observación:
              | {{ observacionEle }}
        footer.modal-card-foot
          button.button.is-success(@click='closeModal') Cerrar
      button.modal-close.is-large(@click='closeModal')

    .modal(v-bind:class="{'is-active':isSending}")
      .modal-background
      .modal-card
        header.modal-card-head
          p 
            strong Enviando correo
        section.modal-card-body
            progress.progress.is-small.is-primary(max='100') 15%
        footer.modal-card-foot      
</template>

<script>
import trackService from '@/services/track'

export default {
  data: () => ({
    track: [],
    isLoading: false,
    isSending: false,
    estado: null,
    isActive: false,
    comprobanteEle: ``,
    autorizacionEle: ``,    
    estadoEle: ``,
    observacionEle: ``
  }),

  props: {
    tracks: { type: Array, required: true }
  },

  computed: {
    pdf () {
      return trackService.pdf()
    },
    xml () {
      return trackService.xml()
    }
  },

  methods: {
    launchModal (codigo, numero) {
      this.comprobanteEle = `${codigo} ${numero}`
      trackService.electronicoById(codigo, numero)
        .then(res => {
          this.track = res
          if (this.track[0].numeroAutorizacion) {
            this.autorizacionEle = this.track[0].numeroAutorizacion
          }
          console.log(`Comprobante ${this.track[0].codigo} ${this.track[0].numero}`)
          this.estadoEle = ' ' + this.track[0].estado
          this.observacionEle = this.track[0].observacion
        })
      this.isActive = true
    },
    
    closeModal () {
      this.isActive = false;
    },

    autorizaUna (codigo, numero) {
      this.isLoading = true
      trackService.autorizaUnaRetencion(codigo, numero)
        .then(res => {
          this.estado = res
          this.buscaValor(codigo, numero, this.estado[0])
          this.isLoading = false
        })
    },

    goToEstado (numero) {
      this.$router.push({ name: 'electronico', params: { numero } })
    },

    buscaValor (codigo, numero, estado = 'NO ENVIADO') {
      for (let i = 0; i < this.tracks.length; i++) {
        if (this.tracks[i].codigo === codigo && this.tracks[i].numero === numero) {
          this.tracks[i].estado = estado
          break
        }
      }
    },

    enviarCorreo (codigo, numero) {
      this.isSending =true
      console.log(`Enviando correo ... ${codigo} ${numero}`)
      trackService.enviarCorreo(codigo, numero)
        .then(res => {
          console.log(`Ejecutado ${res}`)
          this.isSending = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
td.numero {
  text-align: right;
}
th.titulo {
  text-align: center;
}
a.no_enviado {
   pointer-events: none;
   cursor: default;
   opacity: 0.5;
}
a.autorizado_autorizar {
   pointer-events: none;
   cursor: default;
  //  display: none;
   opacity: 0.4;
   color: Black;
}
// a.recibida_autorizar {
//    pointer-events: none;
//    cursor: default;
//   //  display: none;
//    opacity: 0.4;
//    color: Black;
// }
p.no_enviado {
  color: #0066cc;
}
p.devuelta {
  color: #0066cc;
}
</style>
